<template>
    <client-page>

        <sub-visual
        sh="About IST"
        tabActive="Certification Status"
        bg="/images/sub/visual/sv1.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <h2 class="page-tit">
                    Certification Status
                </h2>
            </v-container>
            <top-image
            src="/images/sub/about/status/status-img.png">
            </top-image>
        </section>
        
        <section class="sub-section">
            <v-container>
                <h4 class="tit--md font-weight-bold line-height-1 mb-28 mb-lg-40">
                    Certification acquisition status
                </h4>

                <v-row class="my-n10 my-lg-n40">

                    <certification
                    num="Quality Management System"
                    src="/images/sub/about/status/cert2-1.png">
                        ISO 9001:2015
                    </certification>

                    <certification
                    num="Environmental Management System"
                    src="/images/sub/about/status/cert2-2.png">
                        ISO 14001:2015
                    </certification>

                    <certification
                    num="Information Security Management System"
                    src="/images/sub/about/status/cert2-3-en.png">
                        ISO 27001 : 2013
                    </certification>

                    <certification
                    num="Health Safety Management System"
                    src="/images/sub/about/status/cert2-4-en.png">
                        ISO 45001:2018
                    </certification>

                </v-row>
            </v-container>
        </section>
        
        <section class="sub-section sub-section--last">
            <v-container>
                <h4 class="tit--md font-weight-bold line-height-1 mb-28 mb-lg-40">
                    Patent acquisition status
                </h4>

                <v-row class="my-n10 my-lg-n40">

                    <certification
                    num="No. 10-0879086"
                    src="/images/sub/about/status/cert1-1.png">
                        Retainer-Ring for Polishing Wafer  
                    </certification>

                    <certification
                    num="No. 10-1123870"
                    src="/images/sub/about/status/cert1-2.png">
                        Method for Manufacturing  Retainer-Ring for Polishing Wafer
                    </certification>

                    <certification
                    num="No. 10-1364089"
                    src="/images/sub/about/status/cert1-3.png">
                        Retainer-Ring for Polishing Wafer &  Method of Manufacturing the Same  
                    </certification>

                    <certification
                    num="No. 10-2246289"
                    src="/images/sub/about/status/cert1-4.png">
                        Reusable Retainer-Ring for Polishing Wafer  & Manufacturing
                    </certification>

                    <certification
                    num="No. 10-0879085"
                    src="/images/sub/about/status/cert1-5.png">
                        Retainer-Ring for Polishing Wafer  
                    </certification>

                    <certification
                    num="No. 10-0884236"
                    src="/images/sub/about/status/cert1-6.png">
                        Retainer-Ring for Polishing Wafer  
                    </certification>

                    <certification
                    num="No. 10-2247867"
                    src="/images/sub/about/status/cert1-7.png">
                        Retainer-Ring Using Friction Welding,  Apparatus & Method for Manufacturing Thereof  
                    </certification>

                </v-row>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import TopImage from "@/components/client/en/sub/sub-top-image.vue";
import Certification from "@/components/client/en/sub/sub-certification.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        TopImage,
        Certification,
    },
};
</script>

<style lang="scss" scoped>
</style>